import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var MoneyHelper =
/*#__PURE__*/
function () {
  function MoneyHelper() {
    _classCallCheck(this, MoneyHelper);
  }

  _createClass(MoneyHelper, [{
    key: "GetMoneyReadValue",
    value: function GetMoneyReadValue(number, round, decPlaces, decSep, thouSep) {
      if (typeof number === "string") number = number.replace("$", "");
      var fractionDigits = decPlaces === null || decPlaces === undefined || typeof decPlaces !== 'number' || isNaN(decPlaces) ? 2 : decPlaces;
      var processedNumber = number || 0;

      if (round !== true && fractionDigits < 2) {
        var multiplier = Math.pow(10, fractionDigits);
        processedNumber = Math.floor(processedNumber * multiplier) / multiplier;
      } else if (round === true) {
        processedNumber = Math.round(processedNumber);
      }

      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      });
      return formatter.format(processedNumber);
    }
  }]);

  return MoneyHelper;
}();

export default new MoneyHelper();